/**
 * MDLA business services, or "Streams"
 */
export enum BusinessServices {
    OM_EMEA = 'OM EMEA',
    OM_NAM = 'OM NAM',
    CLW = 'CLW'
}
